export const WARNING = {
  DARK: '#c48e00',
  DEFAULT: '#ebac00',
  LIGHT: '#f7d064',
  LIGHTER: '#fff2b9',
} as const;
